import MDButton from 'components/MDButton'
import React, { useEffect, useState } from 'react'
import MDModal from 'components/MDModal'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import MDInput from 'components/MDInput'
import { useAppServices, useUploadImage } from 'hook/services'
import { useAgencyInfo } from 'context/agency'
import { Checkbox, FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material'
import Editor from 'components/editor'

const CreateModal = ({ handleRefresh }) => {
  const uploadImage = useUploadImage()
  const [agency] = useAgencyInfo()
  const AppService = useAppServices()
  const [openAddProduct, setOpenAddProduct] = useState(false)
  const [processing, setProcessing] = useState(false)
  const [tags, setTags] = useState([])
  const [category, setCategory] = useState([])
  const [isApp, setIsApp] = useState("");
  const [description,setDescription] = useState('')
  const [loader, setLoader] = useState(true)

  const getCategories = async () => {
    const { response } = await AppService.medialibrarycategory.get({
      toaster: false,
    })
    if (response) {
      setCategory(response.data)
    } else {
      setCategory([])
    }
    // setLoader(false)
  }
  const handleModal = () => setOpenAddProduct(true)
  const closeAddProduct = () => setOpenAddProduct(false)

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      const value = e.target.value.trim()
      if (value && !tags.includes(value)) {
        setTags([...tags, value])
        e.target.value = ''
      }
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setProcessing(true)

    const payload = {
      name: e.target.name.value,
      description,
      video_path: e.target.video_path.value,
      transcription: e.target.transcription.value,
      type: e.target.type.value,
      app: isApp,
      priority: Number(e.target.priority.value),
      tags: tags,
      category: e.target.category.value,
    }

    const { response } = await AppService.medialibrary.create({ payload })

    if (response) {
      setProcessing(false)
      closeAddProduct()
      handleRefresh()
    }
  }
  useEffect(() => {
    getCategories()
  }, [])

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 612,
    maxHeight: '80vh',
    overflow: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
  }

  return (
    <>
      <MDButton color="white" variant="contained" onClick={handleModal}>
        Create
      </MDButton>
      <MDModal open={openAddProduct} onClose={closeAddProduct}>
        <MDBox>
          <MDBox component="form" onSubmit={handleSubmit} role="form" sx={style}>
            <MDTypography variant="h5" mb={2}>
              Create Media Library
            </MDTypography>

            {/* Existing fields */}
            <MDBox mb={2}>
              <MDTypography variant="button">Name</MDTypography>
              <MDInput label="Name" name="name" fullWidth required />
            </MDBox>

            <MDBox mb={2}>
              <MDTypography variant="button">Description</MDTypography>
              <Editor handleChange={setDescription} />
            </MDBox>

            <MDBox mb={2}>
              <MDTypography variant="button">Transcription</MDTypography>
              <MDInput label="transcription" name="transcription" fullWidth required />
            </MDBox>

            {/* New Priority Field */}
            <MDBox mb={2}>
              <MDTypography variant="button">Priority Number</MDTypography>
              <MDInput
                label="Priority"
                name="priority"
                type="number"
                fullWidth
                required
                inputProps={{ min: 1 }}
              />
            </MDBox>

            {/* New Tags Field */}
            <MDBox mb={2}>
              <MDTypography variant="button">Tags</MDTypography>
              <MDInput
                label="Add tags (press Enter)"
                onKeyPress={handleKeyPress}
                fullWidth
              />
              <MDBox display="flex" flexWrap="wrap" gap={1} mt={1}>
                {tags.map((tag, index) => (
                  <MDBox
                    key={index}
                    bgcolor="grey.200"
                    px={1}
                    borderRadius="5px"
                    display="flex"
                    alignItems="center"
                  >
                    <MDTypography variant="caption" color="info">{tag}</MDTypography>
                    <MDTypography
                      variant="caption"
                      onClick={() => setTags(tags.filter((_, i) => i !== index))}
                      style={{ cursor: 'pointer', marginLeft: '4px' }}
                    >
                      ×
                    </MDTypography>
                  </MDBox>
                ))}
              </MDBox>
            </MDBox>

            {/* New Category Field */}
            {/* New Category Field */}
            <MDBox mb={2}>
              <MDTypography variant="button">Category</MDTypography>
              <MDInput
                select
                name="category"
                fullWidth
                required
                SelectProps={{ native: true }}
              >
                <option value="">Select a category</option>
                {category.map((cat) => (
                  <option key={cat._id} value={cat._id}>
                    {cat.name}
                  </option>
                ))}
              </MDInput>
            </MDBox>

            {/* Existing Type Field */}
            <MDBox mb={2}>
              <MDTypography variant="button">Type</MDTypography>
              <MDInput
                select
                name="type"
                fullWidth
                required
                SelectProps={{ native: true }}
              >
                <option value="location">Location</option>
                <option value="agency">Agency</option>
                <option value="levelupmarketplace">levelupmarketplace</option>
              </MDInput>
            </MDBox>

            <MDBox mb={2}>
  <MDTypography variant="button">App</MDTypography>
       <div>
       <FormControl component="fieldset">
    <RadioGroup
      row
      name="app"
      value={isApp.toString()} // Convert boolean to string
      onChange={(e) => setIsApp(e.target.value === "true")}
    >
      <FormControlLabel value="true" control={<Radio />} label="True" />
      <FormControlLabel value="false" control={<Radio />} label="False" />
    </RadioGroup>
  </FormControl>
       </div>
            </MDBox>
            <MDBox mb={2}>
              <MDTypography variant="button">Video URL</MDTypography>
              <MDInput label="Video URL" name="video_path" fullWidth />
            </MDBox>

            <MDBox display="flex" justifyContent="flex-end">
              <MDButton
                variant="gradient"
                color="primary"
                type="button"
                sx={{ mt: 2, mb: 1 }}
                onClick={closeAddProduct}
              >
                Close
              </MDButton>
              <MDButton
                variant="gradient"
                color="info"
                type="submit"
                sx={{ mt: 2, mb: 1, ml: 1 }}
                loading={processing}
                disabled={processing}
              >
                Add
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDModal>
    </>
  )
}

export default CreateModal